// المشغّل الأصلي داخل التطبيق (RadioService في أندرويد).
//
// في المتصفح يبقى <audio> كما هو. وداخل التطبيق يُشغّل أندرويد نفسه، كي
// تصل الإذاعة إلى Android Auto وتعمل والتطبيق مغلق. والصفحة هنا لوحة
// تحكم: ترسل الأوامر، وتعرض الحالة التي يعلنها المشغّل لا التي تخمّنها.

const plugin = () =>
  typeof window !== 'undefined' ? window.Capacitor?.Plugins?.RadioPlayback ?? null : null;

export const hasNativePlayer = () =>
  typeof window !== 'undefined' &&
  Boolean(window.Capacitor?.isNativePlatform?.()) &&
  Boolean(plugin()?.play);

/** ما يحتاجه المشغّل من الإذاعة، لا كل ما تحمله الصفحة. */
export const toNativeStation = (s) => ({
  id: String(s.id),
  name: s.name ?? '',
  reciter: s.reciter ?? '',
  category: s.category ?? '',
  url: s.url ?? '',
  backupUrl: s.backupUrl ?? '',
  // السيارة تجلب الصورة برابط؛ صور data: والمولَّدة في الصفحة لا تصلها
  image: /^https?:\/\//.test(s.image ?? '') ? s.image : '',
  // غلاف السيارة يُرسم أصلياً بزخرفة التطبيق، وعلم الدولة جزءٌ منه
  flag: s.countryFlag ?? '',
});

export const nativePlay = (station) => plugin().play({ station: toNativeStation(station) });
export const nativePause = () => plugin().pause();
export const nativeResume = () => plugin().resume();
export const nativeStop = () => plugin().stop();
export const nativeSetVolume = (value) => plugin().setVolume({ value });
export const nativeGetState = () => plugin().getState();

/** القائمة الظاهرة والمفضلة، لشجرة السيارة. */
export const nativeSetStations = (stations, favorites) =>
  plugin().setStations({
    stations: stations.filter((s) => s.isEnabled !== false && s.url).map(toNativeStation),
    favorites: favorites.map(String),
  });

/**
 * يستمع لحالة المشغّل. يعيد دالة الإلغاء.
 *
 * addListener في Capacitor يعيد وعداً بالمقبض؛ إلغاءٌ يسبق وصوله كان
 * سيترك المستمع حيّاً بعد أن يُفكّ المكوّن.
 */
export function onNativeState(callback) {
  let handle = null;
  let cancelled = false;
  Promise.resolve(plugin().addListener('state', callback)).then((h) => {
    if (cancelled) h?.remove?.();
    else handle = h;
  });
  return () => {
    cancelled = true;
    handle?.remove?.();
  };
}
